module.exports = __webpack_public_path__ + "img/tutorial_sp_background.315fad82.png";